import React, {Component} from 'react';
import Sdk from 'api.digitalpages.module.sdk.api';
import './recuperar-senha.css';
import closedEye from './closed-eye.svg';
import openedEye from './opened-eye.svg';

export default class ViewRecuperarSenha extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "newPassword": "",
      "confirmPassword": "",
      "render_preloader": false,
      "render_success": false,
      "render_error": false,
      "error_message": "",
      "token": null,
      "showNewPassword": false,
      "showConfirmPassword": false
    }
  }

  componentDidMount() {
    // Extract token from hash query parameters
    const hash = window.location.hash;
    const queryStart = hash.indexOf('?');
    if (queryStart === -1) {
      this.redirectTo("/user/forgot");
      return;
    }
    const urlParams = new URLSearchParams(hash.substring(queryStart + 1));
    const token = urlParams.get('token');
    if (!token) {
      this.redirectTo("/user/forgot");
      return;
    }
    this.setState({ token });
  }

  async redefinirSenha() {
    const { newPassword, token } = this.state;
    
    this.setState({
      "render_preloader": true,
      "render_error": false
    });

    try {
      await Sdk.Api.dynamic.bridge('auth/v1.0/user/reset/password/token', {
        token: token,
        password: newPassword
      }, 'POST');
      
      this.setState({
        "render_success": true,
        "render_preloader": false
      });
    } catch (e) {
      this.setState({
        "render_error": true,
        "render_preloader": false,
        "error_message": "Token inválido ou expirado. Solicite uma nova recuperação de senha."
      });
    }
  }

  onChangePassword(field, value) {
    this.setState({
      [field]: value
    });
  }

  isValidPassword() {
    const { newPassword, confirmPassword } = this.state;
    return newPassword.length >= 8 && 
           confirmPassword.length >= 8 && 
           newPassword === confirmPassword;
  }

  redirectTo(path) {
    window.location = window.location.origin + window.location.pathname + "#" + path;
  }

  render() {
    const {
      newPassword,
      confirmPassword,
      render_preloader,
      render_success,
      render_error,
      error_message
    } = this.state;

    return <div className="rdp-react-template-view-recuperar-senha">
      <div className="rdp-react-template-view-recuperar-senha-header">
        <span className="rdp-react-template-view-recuperar-senha-header-logo"></span>
      </div>

      {render_preloader &&
        <div className="rdp-react-template-view-recuperar-senha-preloader">
          <div className="rdp-react-template-view-recuperar-senha-preloader-loader"></div>
        </div>
      }

      {render_error &&
        <div className="rdp-react-template-view-recuperar-senha-error">
          <div className="rdp-react-template-view-recuperar-senha-error-box">
            <span className="rdp-react-template-view-recuperar-senha-error-box-icon"></span>
            <h1 className="rdp-react-template-view-recuperar-senha-error-box-title">Erro na redefinição!</h1>
            <p className="rdp-react-template-view-recuperar-senha-error-box-message">
              {error_message}
            </p>
            <button className="rdp-component-btn primary position-left icon-left" onClick={() => this.redirectTo("/user/forgot")}>
              Solicitar Nova Recuperação
            </button>
          </div>
        </div>
      }

      <div className="rdp-react-template-view-recuperar-senha-content">
        {render_success ? (
          <>
            <span className="rdp-react-template-view-recuperar-senha-title">
              Senha redefinida com sucesso!
            </span>
            <p className="rdp-react-template-view-recuperar-senha-message">
              Sua senha foi alterada com sucesso. Agora você pode fazer login com sua nova senha.
            </p>
            <button className="rdp-component-btn primary position-left icon-right" onClick={() => this.redirectTo("/login")}>
              Fazer Login
            </button>
          </>
        ) : (
          <>
            <span className="rdp-react-template-view-recuperar-senha-title">
              Redefinir senha
            </span>

            <div className="rdp-react-template-view-recuperar-senha-input-container">
              <input
                className="rdp-react-template-view-recuperar-senha-input"
                type={this.state.showNewPassword ? "text" : "password"}
                placeholder="Nova senha (mínimo 8 caracteres)"
                value={newPassword}
                onChange={(e) => this.onChangePassword('newPassword', e.target.value)}
              />
              <button
                type="button"
                className="rdp-react-template-view-recuperar-senha-toggle-password"
                tabIndex="-1"
                onClick={() => this.setState({showNewPassword: !this.state.showNewPassword})}
              >
                <img src={this.state.showNewPassword ? openedEye : closedEye} alt="Toggle Password Visibility" />
              </button>
            </div>

            <div className="rdp-react-template-view-recuperar-senha-input-container">
              <input
                className="rdp-react-template-view-recuperar-senha-input"
                type={this.state.showConfirmPassword ? "text" : "password"}
                placeholder="Confirme sua nova senha"
                value={confirmPassword}
                onChange={(e) => this.onChangePassword('confirmPassword', e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' && this.isValidPassword()) {
                    this.redefinirSenha();
                  }
                }}
              />
              <button
                type="button"
                className="rdp-react-template-view-recuperar-senha-toggle-password"
                tabIndex="-1"
                onClick={() => this.setState({showConfirmPassword: !this.state.showConfirmPassword})}
              >
                <img src={this.state.showConfirmPassword ? openedEye : closedEye} alt="Toggle Password Confirmation Visibility" />
              </button>
            </div>

            {confirmPassword && newPassword !== confirmPassword && (
              <p className="rdp-react-template-view-recuperar-senha-error-text">
                As senhas não coincidem
              </p>
            )}

            <div className="rdp-component-btn-group-flex">
              <button className="rdp-component-btn secondary position-left icon-left" onClick={() => this.redirectTo("/login")}>
                Cancelar
              </button>
              <button 
                className={`rdp-component-btn primary position-right icon-right ${!this.isValidPassword() ? "inactive" : ""}`} 
                onClick={() => this.redefinirSenha()}
                disabled={!this.isValidPassword()}
              >
                {render_preloader ? "Aguarde..." : "Confirmar"}
              </button>
            </div>
          </>
        )}
      </div>

      <div className="rdp-react-template-view-recuperar-senha-footer">
        <div className="rdp-react-template-view-recuperar-senha-footer-items">
          <div className="rdp-react-template-view-recuperar-senha-footer-items-content">
            <span className="rdp-react-template-view-recuperar-senha-footer-item" onClick={() => this.redirectTo("/about")}>Sobre</span>
            <span className="rdp-react-template-view-recuperar-senha-footer-item" onClick={() => this.redirectTo("/terms")}>Termos de Uso</span>
            <span className="rdp-react-template-view-recuperar-senha-footer-item" onClick={() => this.redirectTo("/contact")}>Fale Conosco</span>
            <span className="rdp-react-template-view-recuperar-senha-footer-item" onClick={() => this.redirectTo("/faq")}>FAQ</span>
          </div>
        </div>
        <div className="rdp-react-template-view-recuperar-senha-footer-copyright">
          <div className="rdp-react-template-view-recuperar-senha-footer-copyright-content">
            <div className="rdp-react-template-view-recuperar-senha-footer-copyright-left">
              <span>© 2024 Editora Senac São Paulo</span>
            </div>
            <span>Todos os direitos reservados</span>
          </div>
        </div>
      </div>
    </div>;
  }
}